import { getCurrentProfile, loginWithSplatch } from "./api-client";

import type { AccountProfile } from "@marshmallow-duel/simulation";

const ticket = (() => {
  if (typeof window === "undefined") return null;
  const url = new URL(window.location.href);
  const value = url.searchParams.get("splatch_ticket");
  if (!value) return null;
  url.searchParams.delete("splatch_ticket");
  url.searchParams.delete("splatch_return");
  window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
  return value;
})();

export const arrivedFromSplatch = ticket !== null;
let initialAccount: Promise<AccountProfile | null> | null = ticket ? loginWithSplatch(ticket) : null;

export const loadInitialAccount = (): Promise<AccountProfile | null> => {
  initialAccount ??= getCurrentProfile();
  return initialAccount;
};

export const clearAccountCache = (): void => {
  initialAccount = Promise.resolve(null);
};

export const SPLATCH_SIGN_IN_URL = import.meta.env.VITE_SPLATCH_LOGIN_URL ?? "https://splatch.cz/games/marshmallow-duel-reloaded";
